export const CONFIG = {
  cz: {
    title: 'Lexicos jazykové kurzy | Názory a recenze platformy',
    description:
      'Zjistěte vše o Lexicos: metoda výuky a výhody kurzů. Tisíce spokojených studentů. Připojte se k Lexicos a využijte výhod!',
  },
  cs: {
    title: 'Lexicos jazykové kurzy | Názory a recenze platformy',
    description:
      'Zjistěte vše o Lexicos: metoda výuky a výhody kurzů. Tisíce spokojených studentů. Připojte se k Lexicos a využijte výhod!',
  },
  hu: {
    title: 'Lexicos',
    description:
      'Ismerje meg a Lexicos minden részletét: tanítási módszer és a kurzusok előnyei. Több ezer elégedett diák. Csatlakozzon a Lexicoshoz és használja ki az előnyöket!',
  },
  en: {
    title: 'Lexicos',
    description:
      'Find out everything about Lexicos: teaching method and course benefits. Thousands of satisfied students. Join Lexicos and enjoy the benefits!',
  },
  sk: {
    title: 'Lexicos',
    description:
      'Zistite všetko o Lexicos: metóda výučby a výhody kurzov. Tisíce spokojných študentov. Pridajte sa k Lexicos a využite výhody!',
  },
  lt: {
    title: 'Lexicos',
    description:
      'Sužinokite viską apie Lexicos: mokymo metodą ir kursų privalumus. Tūkstančiai patenkintų studentų. Prisijunkite prie Lexicos ir pasinaudokite privalumais!',
  },
  hr: {
    title: 'Lexicos',
    description:
      'Saznajte sve o Lexicosu: metoda poučavanja i prednosti tečajeva. Tisuće zadovoljnih učenika. Pridružite se Lexicosu i iskoristite prednosti!',
  },
  ro: {
    title: 'Lexicos',
    description:
      'Află totul despre Lexicos: metoda de predare și avantajele cursurilor. Mii de studenți mulțumiți. Alătură-te Lexicos și profită de avantaje!',
  },
  lv: {
    title: 'Lexicos',
    description:
      'Uzziniet visu par Lexicos: mācību metode un kursu priekšrocības. Tūkstošiem apmierinātu studentu. Pievienojieties Lexicos un izmantojiet priekšrocības!',
  },
  pl: {
    title: 'Lexicos',
    description:
      'Dowiedz się wszystkiego o Lexicos: metoda nauczania i korzyści z kursów. Tysiące zadowolonych uczniów. Dołącz do Lexicos i skorzystaj z korzyści!',
  },
  bg: {
    title: 'Lexicos',
    description:
      'Научете всичко за Lexicos: метод на обучение и предимства на курсовете. Хиляди доволни студенти. Присъединете се към Lexicos и се възползвайте от предимствата!',
  },
  sl: {
    title: 'Lexicos',
    description:
      'Spoznajte vse o Lexicos: metoda poučevanja in prednosti tečajev. Tisoče zadovoljnih učencev. Pridružite se Lexicos in izkoristite prednosti!',
  },
  de: {
    title: 'Lexicos',
    description:
      'Erfahren Sie alles über Lexicos: Lehrmethode und Vorteile der Kurse. Tausende zufriedener Schüler. Treten Sie Lexicos bei und nutzen Sie die Vorteile!',
  },
  it: {
    title: 'Lexicos',
    description:
      'Scopri tutto su Lexicos: metodo di insegnamento e vantaggi dei corsi. Migliaia di studenti soddisfatti. Unisciti a Lexicos e sfrutta i vantaggi!',
  },
};
